var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400.075,
    height: 304.54,
    viewBox: "0 0 400.075 304.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 20.994,
    height: 157.455,
    transform: "translate(0 20.994) rotate(-90)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 20.994,
    height: 157.454,
    transform: "translate(0 20.994) rotate(-90)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    transform: "translate(-92.745 -168.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361",
    transform: "translate(269.815 168.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359",
    transform: "translate(0 64.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M358.529,255.581c-22.285-38.283-81.844-21.154-82.064-21.091-17.142,21.958-39.573,55.974-49.971,94.3-18.034,66.47,4.122,99.962,4.122,99.962s12.366,25.765,84.506,18.551c24.605-2.461,46.982-1.589,65.878-1.995h0C412.984,380.178,380.854,293.934,358.529,255.581Z",
    transform: "translate(-219.424 -208.728)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M426.163,400.971c1.546-58.226-52.108-160.408-90.174-186.014H282.563a294.548,294.548,0,0,0-22.331,25.761c.219-.063,59.779-17.191,82.064,21.091,22.325,38.354,54.455,124.6,22.471,189.727h0C401.445,450.749,424.99,445.144,426.163,400.971Z",
    transform: "translate(-203.191 -214.957)",
    fill: "#143a4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M283.176,233.334s-44.743-65.58-13.262-64.494,25.652,12.484,45.392,10.313,23.54-16.283,46.337-7.6S331.79,239.4,331.79,239.4Z",
    transform: "translate(-203.804 -168.648)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M329.154,282.756a7.637,7.637,0,0,0,0-15.275H268.665a7.637,7.637,0,0,0,0,15.275H286a18.252,18.252,0,0,1,16.649,10.692h-33.91a7.637,7.637,0,1,0,0,15.275h33.91A18.379,18.379,0,0,1,286,319.416H268.665a7.661,7.661,0,0,0-5.27,13.213l43.229,40.86a7.642,7.642,0,0,0,5.27,2.062,7.874,7.874,0,0,0,5.574-2.366,7.611,7.611,0,0,0-.3-10.77l-29.328-27.724A33.706,33.706,0,0,0,318.692,308.8h10.462a7.637,7.637,0,0,0,0-15.275H318.692a33.344,33.344,0,0,0-4.583-10.693h15.046Z",
    transform: "translate(-202.878 -129.378)",
    fill: "#e9f4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M295.577,385.013",
    transform: "translate(-189.131 -82.625)",
    fill: "#404799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M312.019,392.134s-45.791,0-57.688-25.022c0,0-2.231,19.689,15.891,27.032C270.222,394.144,302.4,395.083,312.019,392.134Z",
    transform: "translate(-205.573 -89.746)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M307.447,218.4s15-22.577,19.038-49.609c0,0,30.937-2.872,19.5,20.921,0,0-4.94,15.657-23.986,38.173Z",
    transform: "translate(-184.41 -168.679)",
    fill: "#143a4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360",
    transform: "translate(63.212 48.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M277.984,221.94A5.038,5.038,0,0,1,275.1,212.7c1.047-.695,26.1-16.847,60.925-4.42a5.04,5.04,0,0,1-3.387,9.494c-29.911-10.668-51.109,2.769-52,3.345A5.045,5.045,0,0,1,277.984,221.94Z",
    transform: "translate(-261.385 -203.601)",
    fill: "#3ec3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M346.074,227.5a5.026,5.026,0,0,1-1.663-.284c-43.907-15.352-72.036-.485-72.313-.331a5.04,5.04,0,1,1-4.821-8.852c1.3-.709,32.382-17.137,80.461-.331a5.04,5.04,0,0,1-1.663,9.8Z",
    transform: "translate(-264.647 -200.991)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M302.764,263.793a5.042,5.042,0,0,1-4.639-7.006c12.879-30.426,1.835-36.449,1.721-36.5.106.052-.527-.324-.527-.324l4.527-8.925c.566.232,5.623,2.482,8.542,9.579,3.921,9.537,2.246,23.031-4.98,40.1A5.044,5.044,0,0,1,302.764,263.793Z",
    transform: "translate(-251.488 -200.644)",
    fill: "#65cefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M343.443,276.644a5.04,5.04,0,0,1-5.668-4.314h0a82.188,82.188,0,0,0-6.041-19.87c-6.122-13.7-14.825-23.114-25.865-27.991a5.041,5.041,0,1,1,4.074-9.221c31.854,14.076,37.591,54.033,37.818,55.727A5.037,5.037,0,0,1,343.443,276.644Z",
    transform: "translate(-249.444 -199.138)",
    fill: "#65cefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(99.508 440.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M97.583,364.856s78.727-4.484,157.455,0Z",
    transform: "translate(-97.583 -362.863)",
    fill: "#f1e28e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 20.994,
    height: 157.455,
    transform: "translate(0 22.986) rotate(-90)",
    fill: "#ca9a27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(0 1.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(7.086 -5.8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 30.884,
    transform: "translate(0 2.509)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y1: 30.884,
    transform: "translate(12.035 1.908)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y1: 30.884,
    transform: "translate(24.07 1.306)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 30.884,
    transform: "translate(36.105)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y1: 30.884,
    transform: "translate(48.139 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    y1: 30.884,
    transform: "translate(60.174 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y1: 30.884,
    transform: "translate(72.209 2.564)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    y1: 30.884,
    transform: "translate(84.244 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    y1: 30.884,
    transform: "translate(120.349 2.391)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 30.884,
    transform: "translate(96.279 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 30.884,
    transform: "translate(132.383 0.966)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y1: 30.884,
    transform: "translate(108.314 1.587)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y1: 30.884,
    transform: "translate(144.418 0.572)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(92.745 415.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M92.745,347.443s78.726-4.484,157.453,0Z",
    transform: "translate(-92.744 -345.45)",
    fill: "#f1e28e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 20.994,
    height: 157.454,
    transform: "translate(0 22.987) rotate(-90)",
    fill: "#ca9a27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(0 1.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    transform: "translate(7.085 -5.8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y1: 30.884,
    transform: "translate(0 2.509)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    y1: 30.884,
    transform: "translate(12.035 1.908)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    y1: 30.884,
    transform: "translate(24.07 1.306)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    y1: 30.884,
    transform: "translate(36.104)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    y1: 30.884,
    transform: "translate(48.139 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    y1: 30.884,
    transform: "translate(60.174 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    y1: 30.884,
    transform: "translate(72.209 2.564)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y1: 30.884,
    transform: "translate(84.244 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_57",
    "data-name": "Line 57",
    y1: 30.884,
    transform: "translate(120.349 2.391)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_58",
    "data-name": "Line 58",
    y1: 30.884,
    transform: "translate(96.279 1)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    y1: 30.884,
    transform: "translate(132.383 0.966)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_60",
    "data-name": "Line 60",
    y1: 30.884,
    transform: "translate(108.314 1.587)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    y1: 30.884,
    transform: "translate(144.418 0.572)",
    fill: "none",
    stroke: "#ecd757",
    strokeMiterlimit: 10,
    strokeWidth: 1.869
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(155.779 327.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 71.857,
    cy: 71.857,
    r: 71.857,
    transform: "translate(3.112)",
    fill: "#ca9a27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 71.857,
    cy: 71.857,
    r: 71.857,
    fill: "#ecd757"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 71.857,
    cy: 71.857,
    r: 71.857,
    fill: "#ecd757"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 57.94,
    cy: 57.94,
    r: 57.94,
    transform: "translate(13.917 13.917)",
    fill: "#ca9a27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(70.587 13.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M189.609,292.359c-.424,0-.847.007-1.269.017a57.938,57.938,0,0,1,0,115.848c.422.008.846.015,1.269.015a57.94,57.94,0,1,0,0-115.88Z",
    transform: "translate(-188.34 -292.359)",
    fill: "#f1e28e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M151.686,350.3a57.939,57.939,0,0,1,56-57.9c-.646-.021-1.294-.036-1.946-.036a57.94,57.94,0,0,0,0,115.88c.651,0,1.3-.014,1.946-.035A57.94,57.94,0,0,1,151.686,350.3Z",
    transform: "translate(-133.88 -278.443)",
    fill: "#b68d24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    transform: "translate(45.203 33.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M205.84,320.359a29.253,29.253,0,0,1,4.522,9.558h10.585l-4.111,12.331h-5.858c-1.747,12.744-10.585,22.713-23.122,24.46L206.914,393.6h-15l-18.955-26.583V354.685h10.277a15.762,15.762,0,0,0,15.415-12.333H170.18l4.111-12.333h23.431a15.693,15.693,0,0,0-14.491-9.558H170.18l4.111-12.331h46.657l-4.111,12.331h-11Z",
    transform: "translate(-170.18 -305.575)",
    fill: "#b68d24",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M207.8,318.531a29.2,29.2,0,0,1,4.522,9.558h10.585l-4.111,12.331h-5.858c-1.746,12.744-10.584,22.713-23.122,24.46l19.059,26.891H193.868l-18.955-26.583V352.857h10.277a15.764,15.764,0,0,0,15.416-12.333H172.138l4.111-12.333H199.68a15.693,15.693,0,0,0-14.491-9.558H172.138l4.111-12.331h46.657l-4.111,12.331h-11Z",
    transform: "translate(-169.401 -306.302)",
    fill: "#ecd757",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.be970965f46d793d53b32b4ed2da3c84.svg";
export { ForwardRef as ReactComponent };